import React from "react";
import { useNavigate } from "react-router-dom";
import "./intro.css";

const Intro = () => {
    const navigate = useNavigate();

    const handleContact = () => {
        navigate("/contactUs");
    }

    return (
        <>
            <div className="intro-container">
                <span className="intro-content">
                    Welcome to <span style={{ color: "#Ff6600", fontFamily:"Glacial Indifference"}}>Born2Scale</span>, where growth isn't just a goal,it's our DNA. We specialize in data-driven marketing strategies that help businesses scale faster, smarter, and sustainably.
                    <br /><br /> From innovative branding to performance-driven campaigns, we craft solutions that maximize impact and ROI.
                    Let's take your brand to the next level, because you were
                    <br /><br /><span className="bs">Born2Scale</span>
                    <div className="intro-button">
                        <button className="contact" onClick={handleContact} > Contact US</button>
                    </div>
                </span>
            </div>
        </>
    )
}

export default Intro;